/**
 * 특정 국가에서 정렬 순서가 다를 때 
 * - countryItem: {name: string(국가명), index: number} // 단, 해당 국가가 포함된 모든 게임들은 {name: string, index: number} 로 지정해야함
 * 
 * 국가별 정렬 순서 동일 
 * - countryItem: string
 * 
 * 특정 국가에서 l10nKey값이 다를 때
 * - countryItem: {name: string(국가명), l10nKey: string}
 * 
 * 권역별/국가별 게임 리스트 - readme 참조
 */

import { AREA_TYPE, COUNTRY_CODE } from './index';

export const GAME = {
    TL: 'tl',
    LW: 'lineagew',
    BNS2: 'bns2',
    TRICKSTERM: 'tricksterm',
    H3: 'h3',
    L2M: 'lineage2m',
    L2MNU: 'lineage2mnaeu',
    L2MRU: 'lineage2mru',
    L2MSA: 'lineage2msa',
    LM: 'lineagem',
    H2: 'h2',
    BNS: 'bns',
    AION: 'aion',
    LOVEBEAT: 'lovebeat',
    L2: 'lineage2',
    LINEAGE: 'lineage',
    JMM: '雀龍門M',
    JIN_JANRYUMON: '真_雀龍門',
    PUZZUP: 'puzzup',
    BATTLE_CRUSH: "BATTLE CRUSH",
    HOYEON: 'hoyeon',
    JOURNEY : 'journey',
    BNSNCWNA: 'bnsncwna',
    AION2: 'aion2',
    HEROES: 'HEROES',
};

const CC = COUNTRY_CODE;

/**
 * 권역관련 common/const/common.js 주석 참조
 */
export const NCK_GAMES = [
    {
        name: [GAME.AION2],
        l10nKey: 'aion2',
        app: 'pc,apple,android',
        url: 'https://aion2.plaync.com',
        urlRc: 'https://rc-aion2.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.JOURNEY],
        l10nKey: 'journey',
        app: 'pc,apple,android',
        url: 'https://journey.plaync.com',
        urlRc: 'https://rc-journey.plaync.com',
        // 국가리스트 : https://ncsoftcorp-my.sharepoint.com/:x:/r/personal/killy1_ncsoft_com/_layouts/15/Doc.aspx?sourcedoc=%7B7CF39B08-4660-429A-A1B0-5D0310B85C5A%7D&file=PLAYNC%25ud648_%25uc5b8%25uc5b4%25uad6d%25uac00%25ub9e4%25uce6d%25ub9ac%25uc2a4%25ud2b8_20240611.xlsx&wdLOR=c84087566-D12A-4759-ABA0-2DDAC616C88A&fromShare=true&action=default&mobileredirect=true&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNDA4MTcwMDQxOSJ9
        // 241 개 
        country: [
            CC.KR, CC.JP, CC.ID, CC.TH, CC.BR, 
            CC.IT, CC.ES, CC.TR, CC.FR, CC.TW, // 10
            CC.HK, CC.MO, CC.SA, CC.AE, CC.QA, 
            CC.DE, CC.CH, CC.AT, CC.RO, CC.MX, // 20
            CC.CL, CC.AR, CC.PE, CC.CO, CC.EC, 
            CC.UA, CC.BY, CC.LT, CC.PL, CC.GR, // 30
            CC.KW, CC.KZ, CC.UZ, CC.AZ, CC.GE, 
            CC.MD, CC.AM, CC.US, CC.MY, CC.SG, // 40
            CC.PH, CC.CA, CC.GB, CC.NO, CC.SE, 
            CC.IE, CC.PT, CC.FI, CC.DK, CC.IN, // 50
            CC.PK, CC.EG, CC.ZA, CC.AU, CC.IL, 
            CC.LU, CC.HU, CC.CZ, CC.LV, CC.SI, // 60
            CC.SK, CC.BG, CC.RS, CC.BA, CC.HR, 
            CC.MK, CC.DZ, CC.TN, CC.MA, CC.GH, // 70
            CC.NG, CC.TZ, CC.KE, CC.IQ, CC.JO, 
            CC.LB, CC.YE, CC.BH, CC.OM, CC.NP, // 80
            CC.KH, CC.LK, CC.KG, CC.NZ, CC.PY, 
            CC.HN, CC.GT, CC.CR, CC.SV, CC.PA, // 90
            CC.VE, CC.UY, CC.BO, CC.JM, CC.TT, 
            CC.DO, CC.MT, CC.CY, CC.EE, CC.GA, // 100
            CC.GM, CC.GD, CC.GN, CC.GW, CC.NA, 
            CC.NE, CC.NI, CC.DM, CC.LA, CC.LR, // 110
            CC.RW, CC.LY, CC.LI, CC.ML, CC.MC, 
            CC.MU, CC.MZ, CC.MV, CC.MM, CC.FM, // 120
            CC.VU, CC.VA, CC.BS, CC.BD, CC.BM, 
            CC.BJ, CC.BZ, CC.BW, CC.BF, CC.WS, // 130
            CC.SM, CC.SN, CC.SC, CC.LC, CC.KN, 
            CC.SO, CC.SB, CC.SD, CC.SR, CC.SL, // 140
            CC.AW, CC.IS, CC.HT, CC.AL, CC.AO, 
            CC.AG, CC.ER, CC.VG, CC.UG, CC.IR, // 150
            CC.ZM, CC.DJ, CC.GI, CC.ZW, CC.TD, 
            CC.CM, CC.CV, CC.KY, CC.KM, CC.CI, // 160
            CC.CG, CC.CD, CC.CU, CC.CW, CC.TJ, 
            CC.TC, CC.TG, CC.TO, CC.TM, CC.PG, // 170
            CC.FJ, CC.GY, CC.GG, CC.GP, CC.GU, 
            CC.GL, CC.NR, CC.AQ, CC.NF, CC.NC, // 180
            CC.NU, CC.TL, CC.LS, CC.RE, CC.MG, 
            CC.MQ, CC.MH, CC.YT, CC.MW, CC.IM, // 190
            CC.MR, CC.ME, CC.MS, CC.MN, CC.UM, 
            CC.VI, CC.BB, CC.BI, CC.BV, CC.BT, // 200
            CC.MP, CC.BN, CC.BQ, CC.GS, CC.ST, 
            CC.MF, CC.BL, CC.PM, CC.EH, CC.VC, // 210
            CC.SH, CC.SJ, CC.AS, CC.AF, CC.AD, 
            CC.AI, CC.SZ, CC.ET, CC.IO, CC.AX, // 220
            CC.WF, CC.JE, CC.GQ, CC.CF, CC.XK, 
            CC.CC, CC.CK, CC.CX, CC.KI, CC.TK, // 230
            CC.TV, CC.PW, CC.PS, CC.FO, CC.FK, 
            CC.PR, CC.GF, CC.TF, CC.PF, CC.PN, // 240
            CC.HM, 
        ]
    },
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: [
            CC.KR, CC.JP, CC.TW, CC.HK, CC.MO,
        ]
    },
    {
        name: [GAME.TL],
        l10nKey: 'tl',
        app: 'pc',
        url: 'https://tl.plaync.com',
        urlRc: 'https://rc-tl.plaync.com',
        // 21개 국가
        country: [ 
            CC.KR, CC.TW, CC.HK, CC.MO, CC.ID, 
            CC.TH, CC.SG, CC.MY, CC.PH, CC.KZ, // 10
            CC.UA, CC.MD, CC.RU, CC.BY, CC.AZ, 
            CC.AM, CC.AE, CC.SA, CC.QA, CC.KW, // 20
            CC.US 
        ]
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com',
        urlRc: 'https://rc-lineagew.plaync.com',
        // 국가리스트 : https://ncsoftcorp-my.sharepoint.com/:x:/r/personal/killy1_ncsoft_com/_layouts/15/Doc.aspx?sourcedoc=%7B7CF39B08-4660-429A-A1B0-5D0310B85C5A%7D&file=PLAYNC%25ud648_%25uc5b8%25uc5b4%25uad6d%25uac00%25ub9e4%25uce6d%25ub9ac%25uc2a4%25ud2b8_20240611.xlsx&wdLOR=c84087566-D12A-4759-ABA0-2DDAC616C88A&fromShare=true&action=default&mobileredirect=true&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNDA4MTcwMDQxOSJ9
        // 12개 국가
        country: [ 
            CC.KR, {name: CC.JP, index: 2}, CC.ID, CC.TH, {name: CC.TW, index: 2}, 
            CC.HK, CC.SA, CC.AE, CC.QA, CC.MY, // 10
            CC.SG, CC.PH,
        ]
    },
    {
        name: [GAME.BNS2],
        l10nKey: 'bns2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com',
        urlRc: 'https://rc-bns2.plaync.com',
         // 5개 국가
        country: [
            CC.KR, {name: CC.JP, index: 1, l10nKey: 'BnS2'}, {name: CC.TW, index: 1, l10nKey: 'BnS2'}, CC.HK, CC.MO, 
        ],
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        // 31개 국가
        country: [ 
            CC.KR, CC.RU, CC.AE, CC.US, CC.CA, 
            CC.DE, CC.GB, CC.FR, CC.BR, CC.IT, // 10
            CC.ES, CC.CL, CC.NO, CC.SE, CC.IE, 
            CC.PT, CC.FI, CC.DK, CC.CH, CC.AR, // 20
            CC.PE, CC.MX, CC.KZ, CC.UZ, CC.AZ, 
            CC.GE, CC.MD, CC.AM, CC.UA, CC.PL, // 30
            CC.GR, CC.BY, CC.LT, CC.IL, CC.KW, 
            CC.AT
        ]
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'pc,apple,android',
        url: 'https://lineagem.plaync.com',
        urlRc: 'https://rc-lineagem.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.BNS],
        l10nKey: 'bns',
        app: 'pc',
        url: 'https://bns.plaync.com',
        urlRc: 'https://rc-bns.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.AION],
        l10nKey: 'aion',
        app: 'pc',
        url: 'https://aion.plaync.com',
        urlRc: 'https://rc-aion.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.LOVEBEAT],
        l10nKey: 'lovebeat',
        app: 'pc',
        url: 'https://lovebeat.plaync.com',
        urlRc: 'https://rc-lovebeat.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://lineage2.plaync.com',
        urlRc: 'https://rc-lineage2.plaync.com',
        country: [CC.KR]
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://lineage.plaync.com',
        urlRc: 'https://rc-lineage.plaync.com',
        country: [CC.KR]
    }
];

export const NCT_GAMES = [
    {
        name: [GAME.AION2],
        l10nKey: 'aion2',
        app: 'pc,apple,android',
        url: 'https://tw.ncsoft.com/aion2',
        urlRc: 'https://rc-tw.ncsoft.com/aion2',
        country: [CC.KR]
    },
    {
        name: [GAME.JOURNEY],
        l10nKey: 'journey',
        app: 'pc,apple,android',
        url: 'https://journey.plaync.com',
        urlRc: 'https://rc-journey.plaync.com',
        country: []
    },
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: []
    },
    {
        name: [GAME.BNS2],
        l10nKey: 'BnS2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com/',
        urlRc: 'https://rc-bns2.plaync.com/',
        country: [],
    },
    {
        name: [GAME.TL],
        l10nKey: 'tl',
        app: 'pc',
        url: 'https://tl.plaync.com',
        urlRc: 'https://rc-tl.plaync.com',
        country: [],
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com/tw/index',
        urlRc: 'https://rc-lineagew.plaync.com/tw/index',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://tw.ncsoft.com/lineage2m/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2m/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCTBns',
        app: 'pc',
        url: 'https://tw.ncsoft.com/bns/index',
        urlRc: 'https://rc-tw.ncsoft.com/bns/index',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCTAion',
        app: 'pc',
        url: 'https://tw.ncsoft.com/aion/',
        urlRc: 'https://rc-tw.ncsoft.com/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCTLineage2',
        app: 'pc',
        url: 'https://tw.ncsoft.com/lineage2/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2/',
        country: []
    }
];

export const NCJ_GAMES = [
    {
        name: [GAME.JOURNEY],
        l10nKey: 'journey',
        app: 'pc,apple,android',
        url: 'https://journey.plaync.com',
        urlRc: 'https://rc-journey.plaync.com',
        country: []
    },
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.JMM],
        l10nKey: 'NCJJmm',
        app: 'apple,android',
        url: 'https://jmm.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'apple,android',
        url: 'https://lineagem-jp.com/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.ncsoft.jp/bns/',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'AION',
        app: 'pc',
        url: 'https://www.ncsoft.jp/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCJLineage2',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage2/',
        country: []
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage/',
        country: []
    }
];

export const NCV_GAMES = [
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'window,apple,android',
        url: 'https://lineage2m.ncvgames.com/',
        country: []
    },
];

export const NCA_EN_US_GAMES = [
    {
        name: [GAME.HEROES],
        l10nKey: 'heroes',
        app: 'steam,pc,apple,android',
        url: 'https://heroes.plaync.com',
        urlRc: 'https://rc-heroes.plaync.com',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://www.lineage2.com/en-us',
        urlRc: 'https://rc.lineage2.com/en-us',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCA_bns',
        app: 'pc, steam',
        url: 'https://bladeandsoul.plaync.com',
        urlRc: 'https://rc-bladeandsoul.plaync.com',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCA_AION',
        app: 'pc',
        url: 'https://www.aiononline.com/en-us',
        urlRc: 'https://rc.aiononline.com/en-us',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
];

export const NCA_EN_GB_GAMES = [
    {
        name: [GAME.HEROES],
        l10nKey: 'heroes',
        app: 'pc,apple,android',
        url: 'https://heroes.plaync.com',
        urlRc: 'https://rc-heroes.plaync.com',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://www.lineage2.com/en-us',
        urlRc: 'https://rc.lineage2.com/en-us',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCA_bns',
        app: 'pc, steam',
        url: 'https://bladeandsoul.plaync.com',
        urlRc: 'https://rc-bladeandsoul.plaync.com',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCA_AION',
        app: 'pc',
        url: 'https://www.aiononline.com/en-us',
        urlRc: 'https://rc.aiononline.com/en-us',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
];

export const NCA_DE_GAMES = [
    {
        name: [GAME.HEROES],
        l10nKey: 'heroes',
        app: 'steam,pc,apple,android',
        url: 'https://heroes.plaync.com',
        urlRc: 'https://rc-heroes.plaync.com',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://www.lineage2.com/en-us',
        urlRc: 'https://rc.lineage2.com/en-us',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCA_bns',
        app: 'pc, steam',
        url: 'https://bladeandsoul.plaync.com',
        urlRc: 'https://rc-bladeandsoul.plaync.com',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCA_AION',
        app: 'pc',
        url: 'https://www.aiononline.com/en-us',
        urlRc: 'https://rc.aiononline.com/en-us',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
];

export const NCA_FR_GAMES = [
    {
        name: [GAME.HEROES],
        l10nKey: 'heroes',
        app: 'steam,pc,apple,android',
        url: 'https://heroes.plaync.com',
        urlRc: 'https://rc-heroes.plaync.com',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://www.lineage2.com/en-us',
        urlRc: 'https://rc.lineage2.com/en-us',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCA_bns',
        app: 'pc, steam',
        url: 'https://bladeandsoul.plaync.com',
        urlRc: 'https://rc-bladeandsoul.plaync.com',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCA_AION',
        app: 'pc',
        url: 'https://www.aiononline.com/en-us',
        urlRc: 'https://rc.aiononline.com/en-us',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
];

export const GAME_AREA_MAP = {
    [AREA_TYPE.NCK]: NCK_GAMES,
    [AREA_TYPE.NCT]: NCT_GAMES,
    [AREA_TYPE.NCJ]: NCJ_GAMES,
    [AREA_TYPE.NCV]: NCV_GAMES,
    [AREA_TYPE.NCA_EN_US]: NCA_EN_US_GAMES,
    [AREA_TYPE.NCA_EN_GB]: NCA_EN_GB_GAMES,
    [AREA_TYPE.NCA_DE]: NCA_DE_GAMES,
    [AREA_TYPE.NCA_FR]: NCA_FR_GAMES,
};
